<script setup>
import { computed, onMounted } from 'vue';
import {
  useFunctionGetter,
  useMapGetter,
  useStore,
} from 'dashboard/composables/store';
import { isEmptyObject } from 'dashboard/helper/commons';
import SallaCard from './SallaCard.vue';
import SallaEditor from './SallaEditor.vue';

const store = useStore();

const integration = useFunctionGetter(
  'integrations/getIntegration',
  'wgpt_salla'
);
const uiFlags = useMapGetter('integrations/getUIFlags');

onMounted(() => {
  if (isEmptyObject(integration.value)) {
    store.dispatch('integrations/get');
  }
});

const showIntegrationHooks = computed(() => {
  return !uiFlags.value.isFetching && !isEmptyObject(integration.value);
});
</script>

<template>
  <div class="overflow-auto w-full my-auto flex flex-wrap h-full">
    <div v-if="showIntegrationHooks" class="w-full">
      <SallaEditor v-if="integration.enabled" :integration="integration" />
      <SallaCard v-else :integration="integration" />
    </div>
  </div>
</template>
